import { useCommonSelector } from '@wajeez-web/stores/common';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import GoogleBtn from '../../components/GoogleBtn';
import { XCircleIcon } from '@heroicons/react/solid';
import { useState } from 'react';
import { AuthActions } from '@wajeez-web/stores/auth';
import { useAppDispatch } from '@wajeez-web/stores/base';
import { Button } from '@wajeez-web/components/ui';
import { useTranslation } from 'react-i18next';
import { MicrosoftLogin } from '../../components/MicrosoftLogin';

export const SignInPage = () => {
  const dispatch = useAppDispatch();

  const [values, setValues] = useState({ email: '', password: '' });

  const alert = useCommonSelector((state) => state.common.alert);
  const isLoading = useCommonSelector((state) => state.common.loading?.show);

  const { t } = useTranslation();

  const handleChange = (e: React.FormEvent<HTMLInputElement>): void => {
    setValues({ ...values, [e.currentTarget.name]: e.currentTarget.value });
  };

  const onSubmit = () => {
    dispatch(AuthActions.signInAsync(values));
  };

  const errorAlert = () => {
    return alert.show && alert.messages ? (
      <>
        {alert.messages.map((error) => (
          <div
            key={`error ${error.message}`}
            className="rounded-md bg-red-50 p-4"
          >
            <div className="flex">
              <div className="flex-shrink-0">
                <XCircleIcon
                  className="h-5 w-5 text-red-400"
                  aria-hidden="true"
                />
              </div>
              <div className="ms-3">
                <h3 className="text-sm font-medium text-red-800">
                  {error.message}
                </h3>
              </div>
            </div>
          </div>
        ))}
      </>
    ) : null;
  };

  // useEffect(() => {
  //   const listener = (event: KeyboardEvent) => {
  //     if (event.code === 'Enter' || event.code === 'NumpadEnter') {
  //       onSubmit();
  //     }
  //   };
  //   document.addEventListener('keydown', listener);
  //   return () => {
  //     document.removeEventListener('keydown', listener);
  //   };
  // });

  return (
    <div className="antialiased font-sans text-sm text-gray-900 dark:text-white flex flex-col w-full h-full min-h-screen bg-body dark:bg-gray-700 z-0 false">
      <div className="flex flex-col justify-center items-center px-3 bg-white dark:bg-gray-600 min-h-screen ">
        <div className="w-full max-w-screen-xl">
          <main className="block md:flex flex-wrap items-center -mx-2">
            <div className="mx-auto max-w-7xl">
              <div className="lg:grid lg:grid-cols-12 lg:gap-8">
                <div className="mt-16 sm:mt-24 lg:mt-0 lg:col-span-6">
                  <div className="text-center  mb-5 text-primary">
                    <img
                      src="assets/images/logo.png"
                      alt="wajeez logo"
                      className="w-16 h-16 rounded-lg text-center m-auto"
                    />
                  </div>
                  <div className=" sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg ">
                    <div className="px-4  sm:px-10">
                      <div className="text-center">
                        <h1 className="uppercase text-2xl mb-3 font-bold leading-none text-primary">
                          <ReturnTranslatedText
                            origintext="Please log in"
                            text={`general.${'Please log in'}`}
                          />
                        </h1>
                      </div>
                      <div className="  ">{errorAlert()}</div>
                      <div className="mt-6">
                        <div className="rounded-lg shadow-sm">
                          <div className="w-full pb-4 flex justify-center items-center">
                            <GoogleBtn />
                          </div>
                          {/* <div className="w-full pb-6">
                            <MicrosoftLogin />
                          </div> */}
                          <div className="w-[85%] mx-auto h-[1px] bg-white"></div>
                          <div className="pt-6">
                            <label
                              htmlFor="mobile-or-email"
                              className="inline-block mb-2"
                            >
                              <ReturnTranslatedText
                                origintext="Email address"
                                text={`inputs.labels.${'Email address'}`}
                              />
                            </label>
                            <input
                              type="text"
                              name="email"
                              value={values.email}
                              onChange={handleChange}
                              id="mobile-or-email"
                              autoComplete="email"
                              placeholder={
                                t(
                                  `inputs.placeholders.${'Email address'}`,
                                  'Email address'
                                ) || ''
                              }
                              required
                              className="block w-full shadow-sm focus:ring-primary focus:border-primary sm:text-sm border-gray-300 rounded-md text-gray-900"
                            />
                          </div>
                          <br />
                          <div className="block mb-3">
                            <label
                              htmlFor="password"
                              className="inline-block mb-2"
                            >
                              <ReturnTranslatedText
                                origintext="Password"
                                text={`inputs.labels.${'Password'}`}
                              />
                            </label>
                            <input
                              id="password"
                              name="password"
                              type="password"
                              value={values.password}
                              onChange={handleChange}
                              onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                  onSubmit();
                                }
                              }}
                              placeholder={
                                t(
                                  `inputs.placeholders.${'Password'}`,
                                  'Password'
                                ) || ''
                              }
                              autoComplete="current-password"
                              required
                              className="block w-full  shadow-sm focus:ring-primary focus:border-primary sm:text-sm border-gray-300 rounded-md text-gray-900"
                            />
                          </div>
                          <br />
                          <div className="w-full">
                            <Button
                              width="full flex justify-center "
                              bg="primary"
                              color="white"
                              title={'Log In'}
                              loading={isLoading}
                              // refName={ButtonLoadingRefNames.SIGN_IN_PAGE.toString()}
                              // onKeyPress={(e) => {
                              //   if (e.key === "Enter") {
                              //     onSubmit();
                              //   }
                              // }}
                              onClick={onSubmit}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
                  <div>
                    <img src={'assets/images/loginImage.svg'} alt="login svg" />
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};
